module.exports = __webpack_public_path__ + "assets/img/share-progress-icob.3953c658.png";